import React from 'react';
import {
    Editor,
    EditorProvider,
} from 'react-simple-wysiwyg';


const TextComponent = ({ value, style }) => {

    return (
        // <div dangerouslySetInnerHTML={{ __html: value }} />

        <EditorProvider>
            <Editor containerProps={{ style }} value={value} disabled >
            </Editor>
        </EditorProvider>
    )
}

export default TextComponent